import React from 'react';

const TickIcon = ({ color = '#4A9CA6', size = 20 }: { color?: string; size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7615 5.89935L9.99928 11.6408L7.6547 9.29617M16.3945 8.54661C17.0951 11.6277 15.5006 14.7706 12.6004 16.0247C9.70021 17.2789 6.31804 16.2881 4.55299 13.6674C2.78793 11.0466 3.14124 7.54005 5.39364 5.32406C7.64604 3.10806 11.1579 2.81192 13.7496 4.61943"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TickIcon;
